import React, {useState} from 'react'
import {Button, Popconfirm} from "antd";
import {deleteAddress} from "../../services/serviceAddress";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const AddressesDelete = ({id, updater}) => {
    const [loadings, setLoadings] = useState([])

    const handleDeleteClick = () => {
        enterLoadingState(setLoadings)
        deleteAddress(id)
            .then(() => {
                exitLoadingState(setLoadings)
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return(
        <React.Fragment>
            <Popconfirm
                title={'Silmek istediğinize emin misiniz ?'}
                okText={'SİL'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'danger', loading: loadings[0]}}
                onConfirm={handleDeleteClick}
            >
                <Button
                    type={'link'}
                    danger
                >
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default AddressesDelete